import { Pipe, PipeTransform } from '@angular/core';

/**
 * Find the first item in the provided array that has a property `id` that
 * matches the provided value.
 */
@Pipe({
    name: 'findById',
    pure: true
})
export class FindByIdPipe implements PipeTransform {
    transform<E extends { id: T }, T = string | number>(
        items: E[],
        itemToFind: T | null
    ): E | undefined {
        if (items == null || items.length === 0) {
            return undefined;
        }

        return items.find(item => item.id === itemToFind);
    }
}
